import cloneDeep from 'lodash-es/cloneDeep'
import Vue from 'vue'
import rootStore from '@vue-storefront/core/store'

let baselineState: Record<string, unknown> | null = null

/**
 * Snapshot Vuex state after modules are registered (first SSR request).
 * Used to replaceState after each render — the singleton store otherwise
 * accumulates product/category payloads across requests when runInNewContext is false.
 */
export function captureSsrStoreBaseline (): void {
  if (baselineState) {
    return
  }
  baselineState = cloneDeep(rootStore.state)
}

export function resetSsrSharedStateAfterRender (): void {
  if (baselineState) {
    rootStore.replaceState(cloneDeep(baselineState))
  }

  delete Vue.prototype.$ssrRequestContext
  delete Vue.prototype.$cacheTags
}
